


















import { Component, Vue, Prop } from 'vue-property-decorator';
@Component({
  components: {},
})
export default class ProfileEntry extends Vue {
  @Prop() private name!: string;
  @Prop() private image!: string;
  @Prop() private position!: string;
}
